const pricingData = [
    {
        header: 'STARTER',
        subscribe: '0',
        list: [
            'Download 5 Games',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
        ]
    },
    {
        header: 'BASIC',
        subscribe: '29',
        list: [
            'Download 25 Games',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
        ]
    },
    {
        header: 'Professional',
        subscribe: '59',
        list: [
            'Download Unlimited Games',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
            'Lorem ipsum dolor sit amet.',
        ]
    },
]

export default pricingData;